import Result from 'antd-mobile/es/result'
import * as service from './service'
export default {
  namespace: 'levelSysMyLevel',
  state: {
    homeData: {},
    marks: []
  },
  effects: {
    * getHomeData ({ payload }, { call, put }) {
      const res = yield call(service.home, payload)
      const calcMark = homeData => {
        const result: string[] = []
        homeData.scoreConf.map(item => {
          result.push(item.addScoreDesc)
        })
        return result
      }
      yield put({
        type: 'save',
        payload: {
          homeData: res.data.data,
          marks: calcMark(res.data.data)
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
